import React from 'react';
import './PageHeader.css';
import './VectorCapitalPageHeader.css';

/**
 * Centered top bar for the Vector Capital route (matches other content pages, not the main dashboard header).
 */
function VectorCapitalPageHeader({ onNavigate }) {
  return (
    <header className="page-header-simple page-header-vector-capital">
      <div className="page-header-simple-content page-header-vector-capital-inner">
        <div className="page-header-side-spacer" aria-hidden="true" />
        <div className="vector-capital-page-header-brand">
          <button
            type="button"
            className="page-header-title-btn vector-capital-page-header-title-btn"
            onClick={() => onNavigate && onNavigate('home')}
          >
            <h1 className="page-header-title vector-capital-page-header-title">Strategy Simulator</h1>
          </button>
          <span className="vector-capital-powered-by">Powered by RiskLo</span>
        </div>
        <div id="risklo-hamburger-slot" className="header-hamburger-slot page-header-hamburger-slot" />
      </div>
    </header>
  );
}

export default VectorCapitalPageHeader;
